var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');
var debounce = require('throttle-debounce/debounce');

var UPDATE_AD_SCROLL_VALUE = 516;
var SCROLL_EVENT_DEBOUNCE = 150;


function init($el) {
    var previousScrollDelta = 0;

    var fireActionOnScrollHeight = debounce(SCROLL_EVENT_DEBOUNCE, function(currentElement) {
        var scrollTop = currentElement.scrollTop();
        var currentScrollDelta =  parseInt(scrollTop / UPDATE_AD_SCROLL_VALUE);
        if (previousScrollDelta !== currentScrollDelta) {
            previousScrollDelta = currentScrollDelta;
            eventToolbox.fireAction({});
        }
    });

    $el.each(function () {
        var $currentElement = $(this);
        $currentElement.off('scroll'); // prevent double event because multiple initialization can occur for defer modules.
        $currentElement.on('scroll', function () {
            fireActionOnScrollHeight($currentElement);
        });
    });
}

module.exports = {
    init: init
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/engagement-handler/scroll-engagement-handler/custom-scroll-engagement-handler.js
// module id = 251
// module chunks = 36